export default __webpack_public_path__ + "static/media/popup-sorry.42325fae.svg";